module.exports = __webpack_public_path__ + "img/bn默认无图.f7e934b7.png";